import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { ModalComponent } from 'components/modal/modal.component';

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [ModalComponent, CommonModule],
  template: `
    <app-modal class="modal-overlay" *ngIf="showDialog()">
  <div class="modal-container">
    <!-- Header do Modal -->
    <div class="modal-header">
      <div class="titulo-modal">
        <h2>{{title()}}</h2>
      </div>
      <button class="btn-fechar-modal" (click)="emitNegativeEmitter.emit()">
        ✖
      </button>
    </div>
    <br />
    <div class="modal-footer">
      <button class="btn_segundario" (click)="emitNegativeEvent()">
        Não
      </button>
      <button class="btn_primeiro" (click)="emitConfirmEvent()">Sim</button>
    </div>
  </div>
</app-modal>

  `,
  styleUrl: './dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent {

  title = input.required<string>();
  showDialog = input.required<boolean>();

  @Output() emitNegativeEmitter = new EventEmitter();
  @Output() emitConfirmEmitter = new EventEmitter();



  emitConfirmEvent() {
    this.emitConfirmEmitter.emit();
  }

  emitNegativeEvent() {
    this.emitNegativeEmitter.emit()
  }
}
